"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M19 13.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M3 7.5A2.5 2.5 0 0 1 5.5 5h13A2.5 2.5 0 0 1 21 7.5V11h.5a1.5 1.5 0 0 1 1.5 1.5v2a1.5 1.5 0 0 1-1.5 1.5H21v.5a2.5 2.5 0 0 1-2.5 2.5h-6.61q.319-.474.55-1h6.06a1.5 1.5 0 0 0 1.5-1.5V16h-2.5a1.5 1.5 0 0 1-1.5-1.5v-2a1.5 1.5 0 0 1 1.5-1.5H20V9h-8.5a.5.5 0 1 1 0-1H20v-.5A1.5 1.5 0 0 0 18.5 6h-13A1.5 1.5 0 0 0 4 7.5v2.061q-.526.231-1 .549zM17.5 12a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h4a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M7.064 12a.5.5 0 0 0-1 0v.387c-.418.05-.791.17-1.088.394-.438.328-.63.814-.63 1.365 0 .552.192 1.038.63 1.366.411.309.968.422 1.588.422.524 0 .826.101.988.223.134.1.23.258.23.565s-.096.465-.23.566c-.162.121-.464.222-.988.222s-.826-.1-.988-.222c-.134-.1-.23-.258-.23-.566a.5.5 0 0 0-1 0c0 .552.192 1.038.63 1.366.297.223.67.344 1.088.394v.387a.5.5 0 1 0 1 0v-.387c.418-.05.791-.171 1.088-.394.438-.328.63-.814.63-1.366s-.192-1.037-.63-1.366c-.41-.308-.967-.421-1.588-.421-.524 0-.826-.101-.988-.223-.134-.1-.23-.258-.23-.565 0-.308.096-.466.23-.566.162-.121.464-.222.988-.222s.826.1.988.222c.134.1.23.258.23.566a.5.5 0 1 0 1 0c0-.552-.192-1.038-.63-1.366-.297-.223-.67-.344-1.088-.394z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.566 20.786a5.351 5.351 0 1 0 0-10.703 5.351 5.351 0 0 0 0 10.703m4.351-5.352a4.351 4.351 0 1 1-8.702 0 4.351 4.351 0 0 1 8.702 0",
    clipRule: "evenodd"
  })]
}), 'MyBenefits');
